<template>
  <div class="inline-item-form">
    <div class="inline-form-grid">
      <div class="inline-form-group">
        <base-label :required="true">Название</base-label>
        <base-input
          v-model="form.title"
          placeholder="Название характеристики"
          :invalid="errors.title"
          @update:modelValue="errors.title = false"
        />
        <span v-if="errors.title" class="error-message">
          Это поле обязательно
        </span>
      </div>

      <div class="inline-form-group">
        <base-label :required="true">Код</base-label>
        <base-input
          v-model="form.code"
          placeholder="Уникальный код"
          :invalid="errors.code"
          @update:modelValue="errors.code = false"
        />
        <span v-if="errors.code" class="error-message">
          Это поле обязательно
        </span>
      </div>
    </div>

    <div class="inline-form-actions">
      <base-primary-button
        @click="save"
        :loading="isLoading"
        class="btn-sm"
      >
        {{ submitLabel }}
      </base-primary-button>
      <base-button @click="$emit('cancel')" class="btn-sm">
        Отмена
      </base-button>
    </div>
  </div>
</template>

<script>
import { useNotificationStore } from "@/stores/notificationStore";

export default {
  name: "CargoPropertyForm",

  props: {
    initialData: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
    submitLabel: { type: String, default: "Сохранить" },
  },

  emits: ["save", "cancel"],

  data() {
    return {
      form: {
        title: "",
        code: "",
      },
      errors: {
        title: false,
        code: false,
      },
    };
  },

  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },

  methods: {
    initForm() {
      if (!this.initialData) return;
      this.form = {
        title: this.initialData.title || "",
        code: this.initialData.code || "",
      };
    },

    validate() {
      this.errors = { title: false, code: false };
      let isValid = true;

      if (!String(this.form.title).trim()) {
        this.errors.title = true;
        isValid = false;
      }
      if (!String(this.form.code).trim()) {
        this.errors.code = true;
        isValid = false;
      }

      if (!isValid) {
        this.notificationStore.showError(
          "Пожалуйста, заполните все обязательные поля корректно"
        );
      }

      return isValid;
    },

    save() {
      if (!this.validate()) {
        this.$nextTick(() => {
          const firstErrorElement = document.querySelector(
            ".invalid, .error-message"
          );
          if (firstErrorElement) {
            const formGroup = firstErrorElement.closest(
              ".inline-form-group"
            );
            (formGroup || firstErrorElement).scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
        return;
      }

      this.$emit("save", {
        title: this.form.title,
        code: this.form.code,
      });
    },
  },

  created() {
    this.initForm();
  },
};
</script>

<style scoped>
.inline-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: var(--base-in-indent);
}

.inline-form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.inline-form-actions {
  display: flex;
  gap: 8px;
}

.btn-sm {
  padding: 6px 14px;
  font-size: 13px;
}

.error-message {
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 12px;
}

@media (max-width: 600px) {
  .inline-form-grid {
    grid-template-columns: 1fr;
  }
}
</style>
